import _ from 'lodash';

import api from '../../../services/CoreAPI';
import * as types from './action-types';
import { UserService } from '../../../services';

const piiRetry = ({ form, queryParams={} }) => ({
    asyncAction: () =>
        api
            .piiRetry({ form, queryParams })
            .then((response) => {
                const user = _.get(response, 'data.user');
                user && UserService.set(user);
                return response;
            })
            .catch((error) => {
                const user = _.get(error, 'data.user');
                user && UserService.set(user);
                throw error;
            }),
    type: types.PII_RETRY,
});

export default { piiRetry };
